import { versionInfoSchema, type VersionInfo } from '@shirma/shared';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type VersionState = { kind: 'loading' } | { kind: 'ok'; info: VersionInfo } | { kind: 'error' };

/** Страница-заглушка фазы 0a: показывает, что клиент и сервер собраны и связаны (/version). */
export function StubPage() {
  const { t } = useTranslation();
  const [version, setVersion] = useState<VersionState>({ kind: 'loading' });

  useEffect(() => {
    const controller = new AbortController();
    fetch('/version', { signal: controller.signal })
      .then((response) => response.json())
      .then((json: unknown) => setVersion({ kind: 'ok', info: versionInfoSchema.parse(json) }))
      .catch(() => {
        if (!controller.signal.aborted) setVersion({ kind: 'error' });
      });
    return () => controller.abort();
  }, []);

  return (
    <main className="stub">
      <h1>{t('app.name')}</h1>
      <p className="tagline">{t('app.tagline')}</p>
      <p>{t('stub.status')}</p>
      <p className="version" data-testid="version">
        {version.kind === 'loading' && t('stub.versionLoading')}
        {version.kind === 'ok' && t('stub.version', { version: version.info.version, gitSha: version.info.gitSha })}
        {version.kind === 'error' && t('stub.versionError')}
      </p>
    </main>
  );
}
